import React from 'react';
import { Note, type NoteProps } from './NotePrimitives';

export const InfoNote = ({
  size,
  className,
  children,
}: React.PropsWithChildren<Pick<NoteProps, 'size' | 'className'>>) => (
  <Note variant="info" size={size} className={className}>
    {children}
  </Note>
);
